// frontend_app/src/lib/searchParams.js
//
// The search page keeps its state in the URL so searches can be bookmarked,
// shared, refreshed and navigated with Back/Forward:
//   /search?q=ferritin&match=full&mode=live&lab=PathWest&specimen=Blood
//          &referral=Referred+out&refine=gold&view=compare&focus=<result id>

import { FACET_KEYS } from './facets';

export const VIEWS = ['list', 'labs', 'compare'];

export const readSearchState = (params) => ({
  q: (params.get('q') || '').trim(),
  mode: params.get('mode') === 'live' ? 'live' : 'cached',
  match: params.get('match') === 'full' ? 'full' : 'titles',
  filters: FACET_KEYS.reduce((acc, key) => ({ ...acc, [key]: params.getAll(key).filter(Boolean) }), {}),
  refine: params.get('refine') || '',
  view: VIEWS.includes(params.get('view')) ? params.get('view') : 'list',
  focus: params.get('focus') || '',
});

/**
 * Apply `patch` to a copy of `params`. Arrays become repeated params; empty
 * values and defaults are removed to keep URLs short.
 */
export const patchParams = (params, patch) => {
  const next = new URLSearchParams(params);
  Object.entries(patch).forEach(([key, value]) => {
    next.delete(key);
    if (Array.isArray(value)) {
      value.filter(Boolean).forEach((v) => next.append(key, v));
    } else if (value !== undefined && value !== null && value !== '' && value !== false) {
      next.set(key, String(value));
    }
  });
  if (next.get('mode') === 'cached') next.delete('mode');
  if (next.get('match') === 'titles') next.delete('match');
  if (next.get('view') === 'list') next.delete('view');
  return next;
};

/** Params for a brand-new search: keeps mode/match, drops filters and selection. */
export const newSearchParams = (q, { mode, match } = {}) =>
  patchParams(new URLSearchParams(), { q, mode, match });
